import React from 'react';
import { withRouter } from 'react-router';
import { Alert, Modal, Spinner, Table } from 'react-bootstrap';
import { PageStatus } from 'enums';
import { Show } from 'Layout';
import { SurveysAPI } from "../../API";

type State = {
    responseData: any,
    partnerId: string,
    surveyId: string,
    surveyStatus: string,
    status: string,
    error: string | null,
};

class PartnerRspdtIds extends React.Component<any, State> {
    constructor(props) {
        super(props);
        this.state = {
            responseData: null,
            partnerId: this.props.partnerId,
            surveyId: this.props.surveyId,
            surveyStatus: this.props.surveyStatus,
            status: PageStatus.None,
            error: null,
        };
    }

    componentDidMount() {
        const { partnerId, surveyId, surveyStatus } = this.state;
        if (partnerId && surveyId && surveyStatus) {
            this.fetchRspdtIds();
        }
    }

    fetchRspdtIds() {
        const { partnerId, surveyId, surveyStatus } = this.state;
        Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => {
                if (!this.props.partnerId) {
                    return Promise.reject(new Error('Invalid ID'));
                }
                return SurveysAPI.getPartnerTestIdsOnTheBasisOfStatus({ partnerId, surveyId, status: surveyStatus });
            })
            .then((respoData) => {
                if (respoData) {
                    let responseData = respoData;
                    this.setState({ responseData, status: PageStatus.Loaded });
                }
            })
            .catch((error) => {
                this.setState({ status: PageStatus.Error, error: error.message });
            });
    }

    render() {
        return (
            <Modal
                centered
                size="lg"
                backdrop="static"
                onHide={this.props.onClose}
                show
                style={{ zIndex: 1202, background: "rgba(0, 0, 0, 0.3)" }}
            >
                <Modal.Header closeButton>
                    <h5 className="mb-0 mt-1">Details</h5>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '78vh', overflow: 'auto' }}>
                    <Show when={this.state.status === PageStatus.Loading}>
                        <div className="d-flex justify-content-center w-100 p-5">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    </Show>
                    <Show when={this.state.status === PageStatus.Loaded && !!this.state.responseData}>
                        <Table responsive size="sm" bordered>
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Survey Unique Id</th>
                                    <th>Partner Reference Id</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.responseData?.map((idDets, index) => (
                                        <tr key={"partnerDets" + index}>
                                            <td>{index + 1}</td>
                                            <td>{idDets.id ?? "-"}</td>
                                            <td>{idDets.rid ?? "-"}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </Table>
                    </Show>
                    <Alert
                        variant="danger"
                        show={this.state.status === PageStatus.Error}
                    >
                        {this.state.error}
                    </Alert>
                </Modal.Body>
            </Modal>
        );
    }
}

const PartnerRspdtIdsWithRouter = withRouter(PartnerRspdtIds);

export { PartnerRspdtIdsWithRouter as PartnerRspdtIds };
